<template>
  <b-modal
    id="add-loan-bank"
    size="lg"
    centered
    no-close-on-backdrop
    @hide="onHideModal"
    title="Add/Edit Bank"
  >
    <form id="add-loan-bank-form" @submit.prevent="submit">
      <b-form-group style="font-weight: 600" label="Sorting">
        <b-form-input
          type="number"
          :value="displayOrdering"
          @input="onOrderingInput"
          placeholder="Order"
        ></b-form-input>
        <small class="form-text text-muted">1 = first, 2 = second, etc.</small>
      </b-form-group>

      <b-tabs content-class="mt-3">
        <b-tab
          title="ภาษาไทย"
          @click="tab = 'th'"
          :active="tab === 'th'"
        >
          <b-form-group style="font-weight: 600" label="Bank Name (Thai)">
            <b-form-input
              type="text"
              v-model="getBankTranslation('th').name"
              placeholder="Bank Name in Thai"
            ></b-form-input>
          </b-form-group>
        </b-tab>

        <b-tab
          title="English"
          @click="tab = 'en'"
          :active="tab === 'en'"
        >
          <b-form-group
            style="font-weight: 600"
            label="Bank Name (English)"
          >
            <b-form-input
              type="text"
              v-model="getBankTranslation('en').name"
              placeholder="Bank Name in English"
            ></b-form-input>
          </b-form-group>
        </b-tab>
      </b-tabs>

      <b-form-group style="font-weight: 600" label="Image">
        <ImageUploadNew
          :dataImage="bankImageData"
          :maxFile="1"
          :uploadSetting="uploadSetting"
          :onFileUploaded="onBankImageUploaded"
        />
        <small class="form-text text-muted">(100px x 100px)</small>
      </b-form-group>

      <b-form-group style="font-weight: 600" label="Interest Rate">
        <b-form-input
          type="number"
          step="0.0001"
          v-model.number="data.interest_rate"
          placeholder="Interest Rate"
        />
      </b-form-group>

      <b-form-group style="font-weight: 600" label="Interest Rate MRTA">
        <b-form-input
          type="number"
          step="0.0001"
          v-model.number="data.interest_rate_mrta"
          placeholder="Interest Rate MRTA"
        />
      </b-form-group>

      <b-form-group style="font-weight: 600" label="Maximum Loan Limit (%)">
        <b-form-input
          type="number"
          v-model.number="data.loan_limit"
          placeholder="Loan Limit"
        />
      </b-form-group>

      <b-form-group style="font-weight: 600" label="Maximum Loan Term (Years)">
        <b-form-input
          type="number"
          v-model.number="data.loan_period"
          placeholder="Loan Period"
        />
      </b-form-group>

      <div v-if="formError" class="text-error mt-2">
        * Please fill in all required fields.
      </div>
    </form>
    <template slot="modal-footer">
      <b-button
        size="sm"
        variant="primary"
        type="button"
        @click="submit"
        form="add-loan-bank-form"
        >Save</b-button
      >
      <b-button size="sm" variant="danger" @click="closeModal">Cancel</b-button>
    </template>
  </b-modal>
</template>

<script>
import ImageUploadNew from '../ImageUploadNew'

export default {
  components: {
    ImageUploadNew,
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        translations: [
          { lang: 'th', name: '' },
          { lang: 'en', name: '' },
        ],
        interest_rate: 0,
        interest_rate_mrta: 0,
          loan_limit: 0,
          loan_period: 0,
          ordering: 0,
        image_url: '',
      }),
    },
    onAddBank: Function,
    onUpdateBank: Function,
    onCancel: Function,
  },
  data: () => ({
    tab: 'th',
    formError: false,
    uploadSetting: {
      showPreview: true,
      showDelete: true,
      showAlt: false,
    },
  }),
  computed: {
    bankImageData() {
      return {
        source: this.data.image_url || '',
        name: '',
      }
    },
    displayOrdering() {
      // Convert 0-based to 1-based for display
      return (this.data.ordering || 0) + 1
    },
  },
  methods: {
    onBankImageUploaded(data) {
      this.data.image_url = data.source || ''
    },
    onOrderingInput(value) {
      // Convert 1-based input to 0-based storage
      const ordering = Number(value) - 1
      this.data.ordering = Math.max(0, ordering)
    },
    getBankTranslation(lang) {
      if (!this.data.translations) {
        this.data.translations = [
          { lang: 'th', name: '' },
          { lang: 'en', name: '' },
        ]
      }
      let translation = this.data.translations.find((t) => t.lang === lang)
      if (!translation) {
        translation = { lang, name: '' }
        this.data.translations.push(translation)
      }
      return translation
    },
    submit() {
      this.formError = false

      const thName = this.getBankTranslation('th').name
      const enName = this.getBankTranslation('en').name

      if (!thName || !enName) {
        this.formError = true
        return
      }

      // Prepare data
      const bankData = {
        translations: this.data.translations.filter((t) => t.name),
          interest_rate: this.data.interest_rate || 0,
          interest_rate_mrta: this.data.interest_rate_mrta || 0,
          loan_limit: this.data.loan_limit || 0,
          loan_period: this.data.loan_period || 0,
          ordering: this.data.ordering || 0,
        image_url: this.data.image_url || '',
      }

      if (this.data.id) {
        this.onUpdateBank(this.data.id, bankData)
      } else {
        this.onAddBank(bankData)
      }
    },
    onHideModal() {
      this.formError = false
    },
    closeModal() {
      if (this.onCancel) {
        this.onCancel()
      }
      this.$bvModal.hide('add-loan-bank')
    },
  },
}
</script>

<style scoped>
.text-error {
  color: red;
}
</style>

